<template>
  <div v-if="!$store.state.site.loading" id="main-wrapper" v-bind:class="$store.state.site.theme"  >
    <sweet-modal id="sweet-modal"></sweet-modal>
    <toaster id="toaster"></toaster>
    <cardModal id="cardModal"></cardModal>
    <clipboard id="clipboard"></clipboard>
    <!--DEV TOOLS-->
    <div v-if="$store.state.site.content.devMode" 
      id="dev-tools"
      class="pull-right" style="position: fixed; bottom: 25px; right: 10px;z-index:1000;">
      <button type="button" @click.prevent="devTools()" 
      class="btn hidden-print"
      :class="devBtn">
         <i :class="devIcon"></i>  Dev Tools</button>
    </div>
    
    <div id="bfapp" v-bind:class="{ 
          'sidebar-mini': $store.state.site.sidebarMini,
          'sidebar-opened': $store.state.site.sidebarOpen,
        }" >
        <!--HEADER-->
        <header-bar v-if="$store.getters.showTopNavBar" > 
        
          <!--CUSTOM SLOTS-->
          <template v-for="(slotObj, index) in slotsArray" :slot="slotObj.slot">
            <html-renderer-old
                :template="slotObj.html" 
                :key="index"
                :app="$store.state.site.content.app"  
                :params="$store.state.site.content.params"  
                :model="$store.getters.getFormSchema(0).model"  
            >
            </html-renderer-old>
          </template>
        </header-bar>
        
        <div class="header" v-if="headerSlot">
            <html-renderer-old
                :template="headerSlot.html" 
                :key="_uid"
                :app="$store.state.site.content.app"  
                :params="$store.state.site.content.params"  
                :model="$store.getters.getFormSchema(0).model"  
              >
            </html-renderer-old>
        </div>
        
        <!--NAVIGATION-->
        <left-nav-bar v-if="$store.getters.showSideNavBar">
        
          <template v-for="(slotObj, index ) in slotsArray" :slot="slotObj.slot">
            <html-renderer-old
                :template="slotObj.html"
                :key="index+'a'" 
                :app="$store.state.site.content.app"  
                :params="$store.state.site.content.params"  
                :model="$store.getters.getFormSchema(0).model"  
            >
            </html-renderer-old>
          </template>
        
        </left-nav-bar>
        
        <!--MAIN FORM-->
        <router-view 
          :key="$route.fullPath"
          :class="$store.state.site.pageTransitionClasses">
          <template v-for="(slotObj, index ) in slotsArray" :slot="slotObj.slot">
            <html-renderer-old
                :template="slotObj.html" 
                :key="index+'b'"
                :app="$store.state.site.content.app"  
                :params="$store.state.site.content.params"  
                :model="$store.getters.getFormSchema(0).model"  
            >
            </html-renderer-old>
          </template>
        </router-view>
        
        <!--APP FOOTER SLOT-->
        <html-renderer-old v-for="(slotObj, index) in _.filter(slotsArray, function(slotObj) { return slotObj.slot == 'appFooter' })" 
            :template="slotObj.html" 
            :key="index+'c'" 
            :app="$store.state.site.content.app" 
            :params="$store.state.site.content.params"
            :model="$store.getters.getFormSchema(0).model"  
            >
        </html-renderer-old>
        
    </div>
        
</div>
</template>

<script>
  
  import { EventBus } from 'Js/eventBus';
  import store from "Js/store";
  
  //Global registrations
  Vue.component('toaster', () =>  import ( /* webpackChunkName: "core1" */ '@/assets/components/common/toaster.vue'));
  Vue.component('cardModal', () =>  import ( /* webpackChunkName: "core1" */ '@/assets/components/common/cardmodal.vue'));
  Vue.component('sweetModal', () =>  import ( /* webpackChunkName: "core1" */ '@/assets/components/common/sweetmodal.vue'));
  Vue.component('loading', () =>  import ( /* webpackChunkName: "core1" */ '@/assets/components/common/loading.vue'));
  Vue.component('clipboard', () =>  import ( /* webpackChunkName: "core1" */ '@/assets/components/common/clipboard.vue'));
  // Vue.component('html-renderer-old', () =>  import ( /* webpackChunkName: "core1" */ 'Mas/htmlRenderer.js'));
  Vue.component('bfcomp', require('@/assets/components/layouts/formGen/custom/bfcomponent.vue').default);

  // TODO not sure why this is here
  Vue.component('multiselect' , () => import ( /* webpackChunkName: "core1" */ 'vue-multiselect'));
  
  var moment = require('moment');
  var numeral = require('numeral');
  var marked = require('marked');
  var _ = require('lodash');
  Vue.prototype.moment = moment;
  Vue.prototype.numeral = numeral;
  Vue.prototype.marked = marked;
  window.moment = moment
  window.numeral = numeral
    
  // COMPONENTS
  Vue.component('header-bar', require('./components/headerblock.vue').default);
  Vue.component('left-nav-bar', require('./components/leftnavbar.vue').default);

  Vue.component('html-renderer-old', {
    render(h) {
      if (!this.templateRender) {
        return h('div', 'loading...');
      }
      else {
        return this.templateRender(
          );
      }
    }
    ,
  
    watch: {
      template: {
        immediate: true, // makes the watcher fire on first render, too.
        handler() {
          // console.log('@HTML-OLD RENDER html: ', this.template )
          var res=Vue.compile(this.template);
          this.templateRender=res.render; // staticRenderFns belong into $options, 
          // appearantly
          this.$options.staticRenderFns=[] // clean the cache of static elements
          // this is a cache with the results from the staticRenderFns
          this._staticTrees=[] // Fill it with the new staticRenderFns
          for (var i in res.staticRenderFns) {
            //staticRenderFns.push(res.staticRenderFns[i]);
            this.$options.staticRenderFns.push(res.staticRenderFns[i])
          } // console.log ('clear errors?')
          // this.error = null
        }
      }
    },
  
    methods: {
      action: function(actions) {
        EventBus.$emit('processActions', {
          actions
        })
      },
      
      validate: function(){
        return true
      },
  
      namedAction: function(name, options) {
        EventBus.$emit('processNamedAction', {
          name,
          options
        })
      }
    },
  
    props: ['template', 'value', 'model', 'props', 'formGen','app', 'params', 'row','schema'],
    
    data() {
      return {
        templateRender: null
      }
    },
    
    // errorCaptured(err, vm, info) {
    //   console.log('BF HTML rendered an error (10020) : ', err,info)
    //   BF.errorThrow (10020, 'BF HTML renderer error (See info for details)' , {err, info})
    //   return false // stop propagation
    // },
  
  }

)


  export default {name: 'app-view',
  methods: {
    devTools: function() {
      EventBus.$emit('processActions', {
        action: "showCardModal",
        function: "action.options.model = model;",
        options: {
          "draggablex": ".pageheader",
          "draggablex": true,
          "scrollable": false,
          "height": "100%",
          "idForm": "0170ADE2-7088-1E47-8D6B-3A23707EA6C3",
          "pivotX": 1.0,
          "pivotY": 0.1,
          "resizable": false,
          "type": "modal",
          "width": "50%"
        }
      }
      )
    }
    ,
  }
  ,
  
  computed: {
    slotsArray: function() {
      return this.$store.state.site.content.slots ? this.$store.state.site.content.slots: []
    }
    ,
    headerSlot: function() {
      return _.find(this.slotsArray, {'slot':'header'})
    }
    ,
  
    devIcon: function() {
      return this.$store.state.site.errors.length? 'fa fa-warning': 'icon-wrench'
    }
    ,
  
    devBtn: function() {
      return this.$store.state.site.errors.length? 'btn-danger': 'btn-success'
    }
  
  
  }
  ,

  components: {
    // VRuntimeTemplate
  }
  ,
  
  data: function() {
    return {}
  }}
</script>

<style>

</style>
